<div
  class="container-fluid text-center bg-danger-subtle border border-danger shadow rounded"
>
  <div>
    <div>
      <h1
        style="
          text-shadow: 2px 2px 2px grey;
          color: orangered;
          font-weight: bold;
        "
      >
        Page Not Found !
      </h1>
    </div>
  </div>
  <div>
    <p>
      <img
        class="img-fluid"
        src="assets/image/404-error.jpg"
        width="680"
        alt="not found"
        style="filter: drop-shadow(10px 10px 10px grey)"
      />
    </p>
  </div>
</div>
